import React from 'react';
import { motion } from 'framer-motion';
import Classes from './KeyFeatures.module.css';
import Table from './Comp/Table/Table'; // still here if you need it
import { CalenderIcon, CalenderSimpleIcon, DollarIcon, ProfileIcon, TeamIcon } from '../../../../../utils/Icons';

/* ─────────────── Icons ─────────────── */
const ChurnIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 512 512">
        <path d="M352 256c0 22.2-1.2 43.6-3.3 64l-185.3 0c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64l185.3 0c2.2 20.4 3.3 41.8 3.3 64zm28.8-64l123.1 0c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l-123.1 0c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32l-116.7 0c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0l-176.6 0c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0L18.6 160C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192l123.1 0c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64L8.1 320C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6l176.6 0c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352l116.7 0zm358.1 0c-30 74.1  -93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6l116.7 0z" />
    </svg>
);

/* Remaining icons unchanged for brevity … */
/* ─────────────────────────────────────── */

/* ──────────── Motion Variants ──────────── */
const container = {
    hidden: {},
    show: {
        transition: { staggerChildren: 0.18 }
    }
};

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } }
};

const card = {
    hidden: { opacity: 0, y: 60 },
    show: i => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.7, ease: 'easeOut', delay: i * 0.15 }
    })
};

const listItemHover = {
    hover: {
        y: -4,
        scale: 1.03,
        boxShadow: '0 6px 18px rgba(0,0,0,0.12)'
    }
};
/* ───────────────────────────────────────── */

export default function KeyFeatures() {
    return (
        <motion.div
            id="features"
            className={Classes.hero}
            variants={container}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
        >
            {/* Heading */}
            <motion.div className={Classes.miniText} variants={fadeUp}>
                Key Features
            </motion.div>

            <motion.h1 className={Classes.subheading} variants={fadeUp}>
                The Easiest Way to Navigate Your Career Journey
            </motion.h1>

            <motion.p className={Classes.text} variants={fadeUp}>
                So you no longer have to choose between “what you know” and “who you know".
            </motion.p>

            {/* Cards */}
            <div className={Classes.cardsCon}>
                {/* Card #1 — Mentorship Monetization */}
                <motion.div
                    custom={0}
                    variants={card}
                    className={`${Classes.card} ${Classes.greenCard}`}
                >
                    <div className={Classes.imageCon}>
                        <img src='/assets/icons/dollar.png' width={30} height={30} draggable={false} />
                    </div>

                    <h3>Mentorship Monetization, Made Easy</h3>
                    <h5>
                        Get paid for your time or give back — share your expertise, insights, and experience to help others achieve their goals and reach new heights.
                    </h5>

                    <div className={Classes.inputCon}>
                        {/* Preview image zooms on card hover */}
                        <motion.img
                            src="/assets/images/profile-card.webp"
                            alt="profile"
                            draggable={false}
                            whileHover={{ scale: 1.07 }}
                            transition={{ type: 'spring', stiffness: 200 }}
                        />
                    </div>
                </motion.div>

                {/* Card #2 — Find Mentors */}
                <motion.div
                    custom={1}
                    variants={card}
                    className={Classes.card}
                >
                    <div className={Classes.imageCon}>
                        <img src='/assets/icons/team.png' width={30} height={30} draggable={false} />
                    </div>

                    <h3>Find the Top Mentors for You</h3>
                    <h5>
                        Whether you know exactly what you want to do, or have no clue. Get your questions answered by top mentors.
                        <br /><br />
                    </h5>

                    <div className={Classes.inputCon} style={{ justifyContent: 'start' }}>
                        <div className={Classes.profileCon}>
                            {/* Each profileCard gets a subtle lift / scale on hover */}
                            {[
                                {
                                    img: 'feature-card-1.png',
                                    name: 'John Smith',
                                    role: 'Product Manager, ',
                                    company: 'Google'
                                },
                                {
                                    img: 'feature-card-2.png',
                                    name: 'Sarah Kim',
                                    role: 'Software Engineer, ',
                                    company: 'Meta'
                                },
                                {
                                    img: 'feature-card-3.png',
                                    name: 'David Martinez',
                                    role: 'Growth Specialist, ',
                                    company: 'HubSpot'
                                }
                            ].map(({ img, name, role, company }, idx) => (
                                <motion.div
                                    key={idx}
                                    className={Classes.profileCard}
                                    variants={listItemHover}
                                    whileHover="hover"
                                >
                                    <div>
                                        <div className={Classes.card_img}>
                                            <img
                                                src={`/assets/avatars/${img}`}
                                                className={Classes.card_inner_img}
                                                alt={name}
                                            />
                                        </div>
                                    </div>

                                    <div className={Classes.widthInherit}>
                                        <div className={Classes.flexBetween}>
                                            <div>
                                                <h5 className={Classes.text1}>{name}</h5>
                                                <h5 className={Classes.text2}>
                                                    {role} <span>{company}</span>
                                                </h5>
                                            </div>

                                            <div>
                                                <button className={Classes.cardBtn} style={{ marginBottom: '5px' }}>
                                                    <ProfileIcon width="13px" height="13px" fill="#888787" />
                                                    <h5>View Profile</h5>
                                                </button>
                                                <button className={Classes.cardBtn}>
                                                    <CalenderIcon width="13px" height="13px" fill="#888787" />
                                                    <h5>Book Meeting</h5>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </motion.div>
            </div>
        </motion.div>
    );
}
